import { usePipelineContext } from '@/context/pipelineContext';
import { useGetDealComplianceTasksQuery } from '@/features/engagements/engagementsApi';
import { useObjectContext } from '@/hooks/useObjectContext';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';

export const CompleteDealTasks = () => {
	const { dealId, dealRow } = useObjectContext();

	const { data, ...tasksQuery } = useGetDealComplianceTasksQuery(
		{ dealId, includeInactive: false },
		{ skip: !dealId },
	);

	const { stages, checkEndorsementStage } = usePipelineContext(dealRow?.pipeline);

	const isNewBusiness = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_NEW_BUSINESS;
	const isRenewal = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_RENEWALS;

	const isEndorsementStage = checkEndorsementStage(dealRow?.dealStage);

	const complianceTasks = useMemo(() => {
		const tasks = data ?? [];

		const endorsementStageIds = (stages ?? [])
			.filter((stage) => stage?.label?.toLowerCase()?.includes('endorsement'))
			.map((stage) => stage?.id);
		if (isEndorsementStage) {
			return tasks.filter((task) => task.stageId === dealRow?.dealStage);
		} else if (isNewBusiness || isRenewal) {
			return tasks.filter((task) => !endorsementStageIds.includes(task.stageId));
		}

		return tasks;
	}, [data, isEndorsementStage, isNewBusiness, isRenewal, dealRow?.dealStage, stages]);

	const completedTasks = useMemo(
		() => complianceTasks.filter((t) => t.completed),
		[complianceTasks],
	);

	// const incompleteTasks = useMemo(
	// 	() => stabilisedTaskSort(complianceTasks).filter((t) => !t.completed),
	// 	[complianceTasks]
	// );

	return (
		<>
			<Stack direction='column' spacing={1}>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<Box sx={{ width: '100%', mr: 1 }}>
						<LinearProgress
							variant='determinate'
							value={
								tasksQuery.isLoading
									? 0
									: complianceTasks.length === 0
										? 100
										: (completedTasks.length / complianceTasks.length) * 100
							}
							sx={{
								height: 10,
								borderRadius: 5,
								'& .MuiLinearProgress-bar': {
									borderRadius: 5,
									height: 10,
									backgroundColor: '#00C759',
								},
							}}
						/>
					</Box>
					<Box sx={{ minWidth: 35, textAlign: 'right' }}>
						<Typography variant='body2' color='text.secondary'>
							{tasksQuery.isLoading
								? '0%'
								: complianceTasks.length === 0
									? '100%'
									: `${Math.round(
											(completedTasks.length / complianceTasks.length) * 100,
										)}%`}
						</Typography>
					</Box>
				</Box>
			</Stack>
		</>
	);
};
